<template>
  <div>
    <div class="flex items-center mb-2">
      <span class="flex-grow text-gray-500 text-sm">已訂品項</span>
      <template v-if="!!ordersTotal">
        <span class="mr-2 text-gray-500 text-sm">已訂購金額</span>
        <span>{{ ordersTotal | commaFormat | priceFormat}}</span>
      </template>
    </div>
    <ul>
      <li v-for="order in orders" :key="`order-${order.id}`" class="mb-2">
        <order-block :order="order" @cancel="cancelOrder" />
      </li>
    </ul>
    <cancel-order
      v-model="showCancelOrderDialog"
      :order-name="orderName"
      :order-uuid="uuid"
      @success="getCurrentMenu"
    />
  </div>
</template>

<script>
import MemberOrders from './MemberOrders';

export default MemberOrders;
</script>

<style lang="scss" scoped>
@import 'MemberOrders';
</style>
